import { Component } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { ErrorService } from '@services/error.service';
import { SessionService } from '@services/session.service';
import { Location } from '@angular/common';
import { Expediente } from '@models/expediente.model';
import { Prestador } from '@models/prestador.model';
import { DangerError } from '@shared/errors/custom.error';
import { LicenciaService } from '@services/licencia.service';
import IExpediente from '@models/expediente.interface';
import { assignToModel } from '@shared/utils/fieldsMap.utils';
import { BaseFuncionalidadComponent } from '@shared/base/base-funcionalidad.component';
import ILicencia from '@models/licencia.interface';
import IDocumento from '@models/documentos.interface';
import { Archivo } from '@models/archivo.model';
import { TerminologiaService } from '@services/terminologia.service';
import { TipoDocumento } from '@models/tipo-documento.model';
import { StateService } from '@services/state.service';
import { Mensajes } from '@shared/enums/mensajes.enum';

@Component({
    selector: 'app-expedientes-detalle-ver-documentos',
    templateUrl: './expedientes-detalle-ver-documentos.component.html',
    styleUrls: ['./expedientes-detalle-ver-documentos.component.scss']
})
export class ExpedientesDetalleVerDocumentosComponent extends BaseFuncionalidadComponent {
    constructor(
        sessionService: SessionService,
        route: ActivatedRoute,
        location: Location,
        router: Router,
        stateService: StateService,
        private errorService: ErrorService,
        private licenciaService: LicenciaService,
        private terminologiaService: TerminologiaService
    ) {
        super(route, sessionService, location, router, stateService);
    }

    isLoading = false; // Variable que maneja el renderizado del spinner de carga inicial junto a isLoadingTD
    isLoadingTD: boolean = false; // Variable que maneja el renderizado del spinner de carga inicial junto a isLoading

    mostrarModal = false; // Variable que maneja el renderizado del modal

    documentosSeleccionados: Archivo[] = []; // Variable que guarda el documento seleccionado

    documentos: Archivo[] = []; // Variable que guarda los documentos de la licencia
    tiposDocumento: TipoDocumento[] = [] // Variable que guarda los tipos de documentos

    ngOnInit() {
        this.obtenerDocumentos();
        this.obtenerTiposDocumentos();
    }

    get mensajeSinPermisos(): string {
        return this.terminologiaService.obtenerMensajePorID(Mensajes.sin_permisos_funcionalidad);
    }

    get mensajeSinPermisosAccion(): string {
        return this.terminologiaService.obtenerMensajePorID(Mensajes.sin_permisos_accion);
    }

    asignarDocumento(file: Archivo, index: number) {
        this.documentosSeleccionados[index] = file;
    }

    abrirModal() {
        this.mostrarModal = true;
    }

    async obtenerTiposDocumentos() {
        if (!this.isProveedorFuncionality) return;
        this.isLoadingTD = true;
        try {
            if (!this.canReadDoc) throw new DangerError(this.mensajeSinPermisosAccion);
            this.tiposDocumento = this.terminologiaService.obtenerTiposDocumentoLicencia();
        } catch (error) {
            this.errorService.handle(error, "Se produjo un error al obtener los tipos de documento.");
        } finally {
            this.isLoadingTD = false;
        }
    }

    async obtenerDocumentos() {
        this.isLoading = true;
        const mostrarMensaje = !this.isProveedorFuncionality;
        try {
            if (!this.canReadDoc) throw new DangerError(this.mensajeSinPermisosAccion);
            this.documentos = await this.licenciaService.obtenerDocumentosLicencia(this.licencia.id, mostrarMensaje);
        } catch (error) {
            this.errorService.handle(error, "Se produjo un error al obtener los documentos de la licencia.");
        } finally {
            this.isLoading = false;
        }
    }

    mostrarDocumento(doc: Archivo) {
        try {
            if (!this.canReadDoc) throw new DangerError(this.mensajeSinPermisosAccion);
            this.stateService.setDocumento(doc);
            this.stateService.setTipoDocumento(doc.tipo);
            this.stateService.setExpediente(this.expediente);
            this.router.navigate(['ver-documento'], {
                relativeTo: this.route
            });
        } catch (error) {
            this.errorService.handle(error, "Se produjo un error al intentar cambiar de página.");
        }
    }

    goSubirDocumento(tipoDocumento: TipoDocumento) {
        try {
            if (!this.canAddDoc) throw new DangerError(this.mensajeSinPermisosAccion);
            this.stateService.setDocumento(null);
            this.stateService.setTipoDocumento(tipoDocumento);
            this.router.navigate(['subir-documento'], {
                relativeTo: this.route
            });
        } catch (error) {
            this.errorService.handle(error, "Se produjo un error al intentar cambiar de página.");
        }
    }
}
